export default __webpack_public_path__ + "static/media/logo_new.af712a07.svg";